import { React, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Grid, Box, Typography, Divider, useMediaQuery, Icon, Skeleton } from '@mui/material'
import { useTheme } from '@mui/material/styles'

// Local imports
import AdxDrawerComponent from 'components/reusable/drawer/AdxDrawerComponent'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxButton from 'components/custom/AdxButton'
import CompanyInfo from 'module/leave/resources/companyInfo'

// API services
import { useGetWorkday } from 'services/api/modules/leave/workday'
import { useGetHoliday } from 'services/api/modules/leave/holiday'

const ManageOperationDay = () => {
  const [company, setCompany] = useState('')
  const [drawerState, setDrawerState] = useState({ right: true })
  const workdays = useGetWorkday()
  const holidays = useGetHoliday()

  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
    navigate(-1)
  }

  useEffect(() => {
    setCompany(CompanyInfo)
  }, [])

  let navigate = useNavigate()
  let theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  const OperationDaysHeader = () => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="subtitle1">{company.name}</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Box>
            <Typography color="alternate.main" variant="subtitle2">
              {company.address}
            </Typography>
          </Box>
          <Box>
            <Box
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
              sx={{ gap: 1 }}
            >
              {matches ? (
                <Icon
                  sx={{
                    fontSize: 7,
                    color: 'light-gray-text.main',
                  }}
                >
                  circle
                </Icon>
              ) : null}
              <Typography color="light-gray-text.main" variant="subtitle2">
                {company.numEmployees} Employees
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <AdxDrawerComponent
      state={drawerState}
      anchor="right"
      onClose={handleDrawer}
      headerprops={<OperationDaysHeader />}
      noPaddingContent
    >
      <AdxTabsBadge scrollButtons={false}>
        <AdxTabsPanel
          label="Public Holidays"
          notification={holidays?.data?.public_holiday?.filter((item) => item.status === 1)?.length}
        >
          <Box sx={{ pt: 1, width: 1 }}>
            {holidays.isLoading ? (
              <Skeleton width={'100%'} height={200} />
            ) : (
              <>
                {holidays?.data?.public_holiday
                  ?.filter((item) => item.status === 1)
                  ?.map((item, index) => (
                    <Box
                      key={index}
                      px={2}
                      py={1}
                      display={'flex'}
                      alignItems={'center'}
                      sx={{
                        width: { xs: 1, lg: 1 },
                      }}
                    >
                      <Box
                        sx={{
                          width: { xs: 1, sm: 1 / 3, lg: 1 / 4.2 },
                        }}
                      >
                        <Typography color="light-gray-text.main" variant="subtitle1">
                          {item.day.slice(0, 3)}, {item.date}
                        </Typography>
                      </Box>
                      <Box sx={{}}>
                        <Typography color="dark-text.main" variant="subtitle1">
                          {item.name}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
              </>
            )}
          </Box>
        </AdxTabsPanel>
        <AdxTabsPanel label="Custom Holidays" notification={holidays?.data?.custom_holiday?.length}>
          <Box sx={{ pt: 1 }}>
            {holidays?.data?.custom_holiday?.map((item, index) => (
              <Box
                key={index}
                px={2}
                py={1}
                display={'flex'}
                alignItems={'center'}
                sx={{
                  width: { xs: 1, lg: 1 },
                }}
              >
                <Box
                  sx={{
                    width: { xs: 1, sm: 1 / 3, lg: 1 / 4.2 },
                  }}
                >
                  <Typography color="light-gray-text.main" variant="subtitle1">
                    {item.day.slice(0, 3)}, {item.date}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: { xs: 1, sm: 1 / 3, lg: 2 / 3 },
                  }}
                >
                  <Typography color="dark-text.main" variant="subtitle1">
                    {item.name}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </AdxTabsPanel>
      </AdxTabsBadge>
    </AdxDrawerComponent>
  )
}

export default ManageOperationDay
